module.exports = __webpack_public_path__ + "static/media/apple_store.3052a230.png";